function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import LocaleKeys from '../../../../../../locales/keys';
var ServiceTaxCustomizeDialogController = /*#__PURE__*/function () {
  function ServiceTaxCustomizeDialogController($ngRedux) {
    _classCallCheck(this, ServiceTaxCustomizeDialogController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      LocaleKeys: LocaleKeys,
      handleSubmitForm: this.handleSubmitForm.bind(this),
      handleCloseDialog: this.handleCloseDialog.bind(this),
      updateServiceTaxValue: this.updateServiceTaxValue.bind(this),
      updatedCustomizedServiceTaxValue: {
        ServiceTaxCustomization: {}
      }
    });
  }
  return _createClass(ServiceTaxCustomizeDialogController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.currentAddresses && changesObj.currentAddresses.currentValue) {
        this.clonedAddresses = clone(this.currentAddresses);
      }
      if (changesObj.serviceTaxModel && changesObj.serviceTaxModel.currentValue) {
        this.updatedCustomizedServiceTaxValue.ServiceTaxCustomization = clone(this.serviceTaxModel);
      }
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      !this.serviceTaxCustomizationForm.$valid ? this.serviceTaxCustomizationForm.$setSubmitted() : this.onSave()(this.updatedCustomizedServiceTaxValue);
    }
  }, {
    key: "handleCloseDialog",
    value: function handleCloseDialog() {
      this.closeModal()();
    }
  }, {
    key: "updateServiceTaxValue",
    value: function updateServiceTaxValue(changedServiceTax) {
      this.updatedCustomizedServiceTaxValue = changedServiceTax;
    }
  }]);
}();
;
export default {
  bindings: {
    closeModal: '&',
    currentAddresses: '<',
    isUpdatingServiceTax: '<',
    onSave: '&',
    serviceTaxModel: '<?'
  },
  controller: ServiceTaxCustomizeDialogController,
  controllerAs: 'ServiceTaxCustomizeDialogController',
  template: require('./service.tax.customize.dialog.template.html')
};